import { css } from "@compiled/react";
import { FormattedMessage } from "react-intl";

import { media } from "@atlaskit/primitives";

import SignupModule from "@/components/signup/bxp-ui-signup/src";
import { ConfluenceOverlayTemplate } from "@/components/signup/layouts";
import SiteActivation from "@/components/signup/site-activation";
import { useNewUser } from "@/components/user-context";
import { ClientOnly } from "@/utils/client-only";
import { FeatureExposed } from "@/utils/feature-exposed";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

import {
    CreateAWorkspaceHeading,
    SubHeading,
    WelcomeBackHeading
} from "../../../components";

export const LoggedInConfluenceFree = () => {
    const isNewUser = useNewUser();

    if (checkFeatureFlagGate(featureFlags.signupModuleDeprecation)) {
        return (
            <FeatureExposed
                experimentKey="cfind-3467-signup-with-image-overlay"
                group="isTreatment"
            >
                <ConfluenceOverlayTemplate size="sm">
                    <div css={headerOffsetForBlueBackgroundCss}>
                        {isNewUser ? (
                            <>
                                <CreateAWorkspaceHeading />
                                <SubHeading>
                                    <FormattedMessage
                                        id="BxpUiSignup.nameSite.subHeader.newWorkspaceSubHeader"
                                        defaultMessage="This is the URL for your team to access Confluence. Most people use their team or company name."
                                    />
                                </SubHeading>
                            </>
                        ) : (
                            <>
                                <WelcomeBackHeading />
                                <SubHeading>
                                    <FormattedMessage
                                        id="BxpUiSignup.nameSite.cobrandedSubHeader"
                                        defaultMessage="It’s free for up to 10 users - no credit card needed."
                                    />
                                </SubHeading>
                            </>
                        )}
                    </div>
                    <SiteActivation />
                </ConfluenceOverlayTemplate>
            </FeatureExposed>
        );
    }

    return (
        <ClientOnly>
            <SignupModule
                bundle="confluence"
                edition="free"
                isNewUser={isNewUser}
            />
        </ClientOnly>
    );
};

const headerOffsetForBlueBackgroundCss = css({
    marginBlockStart: 54,
    [media.above.sm]: {
        marginBlockStart: 0
    }
});
